/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Badge,
  Button
} from "shards-react";

import PageTitle from "../components/common/PageTitle";

class BlogPosts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Fourth list of posts.
      PostsListFour: [
        {
          backgroundImage: require("../../dashboard-wiki/images/content-management/Icebreakers_Work_Small.jpg"),
          author: "Alene Trenton",
          authorUrl: "#",
          category: "News",
          categoryUrl: "#",
          title: "120+ Best Icebreaker questions for Team Building at work place",
          body:
            "Workplace appropriate Ice-breaker questions for your work meeting. 120+ fun questionnaire for your next team building activity on Zoom or Slack.",
          date: "29 February 2019",
          pageUrl: "https://www.ricotta.team/blog/icebreaker-questions-for-team-building-work"
        },
        {
          backgroundImage: require("../../dashboard-wiki/images/content-management/Would_you_rather.jpg"),
          author: "Chris Jamie",
          authorUrl: "#",
          category: "News",
          categoryUrl: "#",
          title: "40 Would you rather questions for work",
          body:
            "Workplace appropriate would you rather Icebreaker questions for your team on Slack. It's Friday afternoon and you've just finished a lot of work and you are bored working remotely.",
          date: "29 February 2019",
          pageUrl: "https://www.ricotta.team/blog/would-you-rather-questions-for-work-place"
        },
        {
          backgroundImage: require("../../dashboard-wiki/images/content-management/Slack_Channel.jpg"),
          author: "Monica Jordan",
          authorUrl: "#",
          category: "News",
          categoryUrl: "#",
          title: "14 Slack channels your team must have!",
          body:
            "A Slack workspace with just #General and #Random channels tend to be a tad boring. Whereas the more illustrious workspaces with 10+ relevant channels can prove to be more effective with communication.",
          date: "29 February 2019",
          pageUrl: "https://www.ricotta.team/blog/slack-channel-ideas"
        },
        {
          backgroundImage: require("../../dashboard-wiki/images/content-management/Virtual_Games_Small.jpg"),
          author: "Monica Jordan",
          authorUrl: "#",
          category: "News",
          categoryUrl: "#",
          title: "10+ Fun Virtual Team Building Activities and Games for your Remote Team",
          body:
            "Must-try Virtual Team Building Activities, Games and Ideas for remote team engagement online on Slack or Zoom conference calls for your team.",
          date: "29 February 2019",
          pageUrl: "https://www.ricotta.team/blog/virtual-team-building-activities-games"
        }
      ]
    };
  }

  render() {
    const {
      PostsListFour
    } = this.state;

    return (
      <Container fluid className="main-content-container px-4">
        {/* Fourth Row of posts */}
        <Row>
          {PostsListFour.map((post, idx) => (
            <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post h-100 blogCardsDashboard" onClick={() => window.open(post.pageUrl, "_blank")}>
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url('${post.backgroundImage}')` }}
                />
                <CardBody>
                  <h5 className="card-title">
                      {post.title}
                  </h5>
                  <p className="card-text">{post.body}</p>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    );
  }
}

export default BlogPosts;

